import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { SvgIcon } from "../SvgIcon";
export var Critical = function Critical(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.474 12.889A5.967 5.967 0 018 14c-3.308 0-6-2.693-6-6 0-1.294.412-2.493 1.111-3.474l8.363 8.363zm1.415-1.414L4.526 3.11A5.966 5.966 0 018 2c3.307 0 6 2.693 6 6a5.967 5.967 0 01-1.111 3.475zM8 0a8 8 0 110 16A8 8 0 018 0z",
    fill: "currentColor"
  }));
};
export default Critical;